import { useEffect, useState } from "react";
import formatTimeAgo from "../../components/hooks/formatTimeAgo";

export function useTimeAgo(date: Date): any {
  const [timeAgo, setTimeAgo] = useState(() => formatTimeAgo(date));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeAgo(formatTimeAgo(date));
    }, 60 * 1000); // update every minute

    return () => clearInterval(interval);
  }, [date]);

  return {timeAgo, setTimeAgo};
}